import { YooKassaPaymentWithEmail, YooKassaSuccessPayment } from './components';

export { YooKassaSuccessPayment, YooKassaPaymentWithEmail };
